import { render, staticRenderFns } from "./LabaRugiReportTable.vue?vue&type=template&id=292ac3c8&scoped=true"
import script from "./LabaRugiReportTable.vue?vue&type=script&lang=js"
export * from "./LabaRugiReportTable.vue?vue&type=script&lang=js"
import style0 from "./LabaRugiReportTable.vue?vue&type=style&index=0&id=292ac3c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292ac3c8",
  null
  
)

export default component.exports